import { LogLevel } from "@azure/msal-browser";

export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_CLIENT_ID,
        authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID}`,
        redirectUri: process.env.REACT_APP_REDIRECT_URI,
        postLogoutRedirectUri: process.env.REACT_APP_REDIRECT_URI,
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            logLevel: LogLevel.Info,
            piiLoggingEnabled: false,
            loggerCallback: (level, message, containsPii) => {
                if (!containsPii) {
                    switch (level) {
                        case LogLevel.Error:   console.error(message); break;
                        case LogLevel.Warning: console.warn(message); break;
                        case LogLevel.Info:    console.info(message); break;
                        case LogLevel.Verbose: console.debug(message); break;
                    }
                }
            },
        },
    },
};

// scopes for interactive login/popup
export const loginRequest = {
    scopes: ["openid", "profile"],
};

// scopes for silent SSO
export const silentRequest = {
    scopes: ["openid", "profile"],
};